import React, { useState } from 'react';
import { Grid } from '@chakra-ui/layout';
import { Item } from '../item';
import { useCategories } from "../../hooks";
import { ICategoriesProps } from './categories.types';

export const Categories = ({ onSelectCategory }: ICategoriesProps) => {

  const [category, setCategory] = useState([])
  const fetchedCategories  = useCategories();

  async function fetchCategory(){
    const data: any = (await fetchedCategories).data 
    setCategory(data)
  }

  fetchCategory()
  return <>
    <Grid
      templateColumns="repeat(2, 1fr)" gap="8px"
    >
      {category.map(({ name, gif }: any) => {
        return <Item key={name} onClick={() => onSelectCategory(name)} name={name} gif={gif} />
      })}
    </Grid>
  </>
};